<template>
  <div class="collectionNavCategory"
    :style="categoryStyle">
    <div v-if="!isIntro" class="categoryWrap"
      :style="listStyle">
      <div class="categoryList" :style="categoryHeight">
        <router-link
          v-for="item in categoryList"
          :key="item.categoryId"
          :to="categoryRouteInfo(item.categoryId)"
          class="categoryItem">
          <span class="name" :style="fontStyle">{{ item.categoryLabel[lang] }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollectionCategory',
  props: [
    'locale',
    'lang',
    'pageId',
    'setting'
  ],
  computed: {
    isIntro () {
      const megaMenu = this.$store.getters['collection/getMegaMenu']
      return this.$route.name === 'collectionCover' || this.$route.name === 'collectionIntro' || megaMenu
    },
    categoryHeight () {
      const setting = this.setting
      const category = setting && setting.category
      return {
        height: `${category && category.height}px`
      }
    },
    categoryStyle () {
      const setting = this.setting
      const category = setting && setting.category
      const frame = this.$store.getters['collection/getPageFrame']
      return {
        backgroundColor: category && category.backgroundColor,
        ...frame && {
          paddingLeft: `${frame}px`,
          paddingRight: `${frame}px`
        }
      }
    },
    listStyle () {
      const setting = this.setting
      const category = setting && setting.category
      return {
        borderColor: category && category.borderColor,
      }
    },
    fontStyle () {
      const setting = this.setting
      const category = setting && setting.category
      return {
        borderColor: category && category.text && category.text.color
      }
    },
    categoryList () {
      const categoryId = this.$route.params.categoryId
      const isCategoryMain = this.$route.name === 'collectionCategoryMain'
      return this.$store.getters['collection/getSiblingsCategory'](categoryId, isCategoryMain)
    }
  },
  methods: {
    categoryRouteInfo (categoryId) {
      const categoryItem = this.categoryList.find(x => x.categoryId === categoryId)
      const categoryRouteName = categoryItem.useMain
        ? 'collectionCategoryMain'
        : 'collectionPage'
      return {
        name: categoryRouteName,
        params: {
          ...this.$route.params,
          categoryId: categoryId
        }
      }
    }
  }
}
</script>